// extracted by mini-css-extract-plugin
module.exports = {"prospect_template__main":"ProspectTemplateCategory_prospect_template__main__k04sF","second-form":"ProspectTemplateCategory_second-form__YznbO"};